import React from "react";
import { ChatTeardropTextIcon, ArrowRightIcon } from "@phosphor-icons/react";
import { useGo, useTranslate } from "@refinedev/core";
import { useChatHistory } from "../../hooks/useChatHistory";
import {
  DSection,
  DSectionLabel,
  ChatHistoryRowD,
  ChatHistoryLeftD,
  ViewHistoryLinkD,
} from "./drawer-styled";

type ChatHistorySectionProps = {
  projectId: string;
};

export const ChatHistorySection: React.FC<ChatHistorySectionProps> = ({
  projectId,
}) => {
  const t = useTranslate();
  const go = useGo();

  const { data, isLoading } = useChatHistory({
    projectId,
    params: { page: 1, size: 1 },
    enabled: !!projectId,
  });

  const totalMessages = data?.[0]?.total ?? 0;
  const totalConversations = data?.[0]?.data?.length
    ? data.reduce((acc, page) => acc + (page.data?.length ?? 0), 0)
    : 0;

  return (
    <DSection>
      <DSectionLabel>
        {t(
          "media.components.ProjectSettingsDrawer.chatHistory",
          "Chat history"
        )}
      </DSectionLabel>
      <ChatHistoryRowD>
        <ChatHistoryLeftD>
          <ChatTeardropTextIcon size={16} color="#6B7280" />
          {isLoading
            ? "..."
            : `${totalMessages} messages across ${totalConversations} conversations`}
        </ChatHistoryLeftD>
        <ViewHistoryLinkD
          onClick={() =>
            go({
              to: `/media/projects/${projectId}/chat-history`,
            })
          }
        >
          {t(
            "media.components.ProjectSettingsDrawer.viewHistory",
            "View history"
          )}
          <ArrowRightIcon size={12} />
        </ViewHistoryLinkD>
      </ChatHistoryRowD>
    </DSection>
  );
};
